import { Grid, Typography } from "@mui/material";
import { settings } from "app";
import { ArrayInput, minValue, NumberInput, required, SelectInput, SimpleFormIterator } from "react-admin";
import { SpecialistTaxBillingPeriodChoices, SpecialistTaxTypeChoices } from "utils/choices";

const TaxesInfo = () => {
  return (
    <>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ mt: 2 }}
        >
          Такси
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ArrayInput
          source="taxes"
          label=""
          defaultValue={SpecialistTaxTypeChoices.map(({ id }) => ({ type: id }))}
        >
          <SimpleFormIterator
            inline
            sx={settings.style.iteratorWithoutGap}
            disableAdd
            disableRemove
            disableReordering
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <SelectInput
                source="type"
                label="Тип такса"
                choices={SpecialistTaxTypeChoices}
                emptyText={false}
                readOnly
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <SelectInput
                source="billingPeriod"
                label="Период на фактуриране"
                validate={required()}
                choices={SpecialistTaxBillingPeriodChoices}
                emptyText={false}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <NumberInput
                source="amount"
                label="Сума"
                validate={[required(), minValue(0.01, "Сумата трябва да е положителна")]}
                onWheel={e => e.target.blur()}
              />
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default TaxesInfo;
